<template>
  <ElButton
    type="primary"
    @click="showDialog()"
  >
    {{ title }}

    <ElDialog
      append-to-body
      :title="title | ucwords"
      top="25vh"
      :visible.sync="showForm"
    >
      <ElForm
        label-position="left"
        @submit.native.prevent
      >
        <ElInputNumber
          v-model="updateLinks"
          class="width-100"
          :min="0"
        />
      </ElForm>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <ElButton
          class="margin-right-unit"
          type="text"
          @click="showForm = false"
        >
          Cancel
        </ElButton>

        <ElButton
          type="primary"
          :disabled="links === updateLinks"
          @click="changeAvailableLinks()"
        >
          Submit
        </ElButton>
      </span>
    </ElDialog>
  </ElButton>
</template>

<script>
import axios from '@/axios/axios'

export default {
  name: 'ChangeAssessments',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showForm: false,
      updateLinks: null
    }
  },
  computed: {
    title() {
      return 'CHANGE ASSESSMENTS'
    },

    profile() {
      return this.user.profile
    },

    links() {
      return this.profile.availableLinks
    }
  },
  methods: {
    showDialog() {
      this.updateLinks = this.links
      this.showForm = true
    },

    changeAvailableLinks() {
      const data = {
        profileId: this.profile.id,
        availableLinks: this.updateLinks
      }

      axios.post('admin/change-available-links', data)
        .then(res => {
          const updateData = {
            id: this.user.id,
            availableLinks: this.updateLinks
          }

          this.$store.commit('updateRecruiterProfile', updateData)

          this.successNotification(res.data)

          this.showForm = false
        })
        .catch(axios.handleError)
    }
  }
}
</script>
